var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_23561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "url(#paint0_linear_1819_23561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4066 26.8135C21.7063 26.8135 26.8132 21.7065 26.8132 15.4069C26.8132 9.10716 21.7063 4.00024 15.4066 4.00024C9.10691 4.00024 4 9.10716 4 15.4069C4 21.7065 9.10691 26.8135 15.4066 26.8135Z",
    fill: "url(#paint1_linear_1819_23561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.368 11.5181H17.6027C17.474 10.8659 17.1951 10.2523 16.7875 9.72029H20.368C20.8421 9.72029 21.2283 9.33628 21.2283 8.86002C21.2283 8.38377 20.8443 7.99976 20.368 7.99976H9.86456C9.39045 7.99976 9.00429 8.38377 9.00429 8.86002C9.00429 9.33628 9.3883 9.72029 9.86456 9.72029C9.86456 9.72029 9.86456 9.72029 9.86671 9.72029H13.3099C14.0179 9.72029 14.6851 9.99704 15.1871 10.4969C15.4788 10.7887 15.6934 11.1362 15.8221 11.5159H9.86027C9.38616 11.5159 9 11.8999 9 12.3762C9 12.8524 9.38401 13.2365 9.86027 13.2365H15.8221C15.4638 14.2812 14.4727 15.0342 13.3099 15.0342H9.91176C9.63287 15.0192 9.35398 15.1372 9.17377 15.3775C8.88844 15.7572 8.96568 16.2957 9.34539 16.581L16.352 21.8306C16.5064 21.9464 16.6866 22.0022 16.8668 22.0022C17.1286 22.0022 17.386 21.8842 17.5555 21.6589C17.8408 21.2792 17.7636 20.7407 17.3839 20.4554L12.4432 16.7548H13.3078C15.4273 16.7548 17.1972 15.2402 17.5984 13.2365H20.3658C20.84 13.2365 21.2261 12.8524 21.2261 12.3762C21.2261 11.8999 20.8421 11.5159 20.3658 11.5159L20.368 11.5181Z",
    fill: "url(#paint2_linear_1819_23561)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1819_23561",
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE80FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1819_23561",
    x1: 15.4066,
    y1: 26.8135,
    x2: 15.4066,
    y2: 4.00024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1819_23561",
    x1: 15.1163,
    y1: 22.0022,
    x2: 15.1163,
    y2: 8.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE80FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_23561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlLogo);
export default __webpack_public_path__ + "static/media/pl-logo.59bbf63edb7105e0d0234a15884c05a0.svg";
export { ForwardRef as ReactComponent };